<div class="db-download-manager-recreate__content">
  <div class="db-download-manager-recreate__header">
    <h2 class="mb5">Build With AI Builder</h2>
    <p class="mb50">Install the 10Web Manager plugin to be able to recreate<br> websites with AI assistance of the 10Web builder.</p>
  </div>

  <ul class="db-download-manager-recreate__steps">
    <li><i class="db-icon db-icon-ds-checkmark-bg"></i> Download 10Web Manager Plugin
      <a class="ds-btn-blue ml8" [href]="downloadLink$ | async" download (click)="downloadManagerPluginEvent()">
        <span><i class="db-icon db-icon-ds-download"></i>Download</span>
      </a>
    </li>
    <li><i class="db-icon db-icon-ds-checkmark-bg"></i> Install and activate the plugin from the WP admin</li>
  </ul>

</div>

<div class="db-download-manager-recreate__banner"></div>
